var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVSingle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666884 4.99997C0.66644 5.07674 0.681155 5.15285 0.710184 5.22392C0.739213 5.29499 0.781986 5.35963 0.836051 5.41414L4.33605 8.91414C4.44589 9.02398 4.59487 9.08569 4.75022 9.08569C4.90556 9.08569 5.05454 9.02398 5.16438 8.91414C5.27423 8.8043 5.33594 8.65532 5.33594 8.49997C5.33594 8.34463 5.27423 8.19565 5.16438 8.08581L2.07272 4.99997L5.15855 1.91414C5.25412 1.80255 5.30405 1.659 5.29838 1.51219C5.29271 1.36538 5.23185 1.22612 5.12796 1.12223C5.02407 1.01834 4.88481 0.957479 4.738 0.951808C4.59119 0.946137 4.44764 0.996074 4.33605 1.09164L0.836051 4.59164C0.728283 4.70029 0.667528 4.84694 0.666884 4.99997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSingle);
export default __webpack_public_path__ + "static/media/v_single.c9d62eed542916ee60afb4f3be9da513.svg";
export { ForwardRef as ReactComponent };